<template>
  <div
    class="w-full h-auto px-8 pt-4 pb-5 border-t border-zinc-200 justify-between items-center inline-flex min-h-fit"
  >
    <div
      class="text-blue_primary text-lg font-semibold font-['Public Sans'] leading-snug"
    >
      Page {{ pagination.currentPage }} of {{ pagination.totalPages }}
    </div>
    <div class="justify-start items-start gap-4 flex">
      <button
        @click="previous()"
        class="px-5 py-3 rounded-xl shadow-lg border border-slate-300 justify-center items-center gap-2 flex bg-blue_primary"
      >
        <div
          class="text-white text-lg font-semibold leading-snug"
        >
          Previous
        </div>
      </button>
      <button
        @click="next()"
        class="px-5 py-3 rounded-xl shadow-lg border border-slate-300 justify-center items-center gap-2 flex bg-blue_primary"
      >
        <div
          class="text-white text-lg font-semibold leading-snug"
        >
          Next
        </div>
      </button>
    </div>
  </div>
</template>
  <script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const pagination = computed(() => store.getters.pagination);

    async function next() {
      if (pagination.value.currentPage != pagination.value.totalPages) {
        await store.commit("setLoading", true);
        pagination.value.filters.page =  pagination.value.filters.page + 1;
        await store.dispatch("fetchData", pagination.value.filters);
        await store.commit("setLoading", false);
      }
    }

    async function previous() {
      if (pagination.value.currentPage >= 2) {
        await store.commit("setLoading", true);
        pagination.value.filters.page = pagination.value.filters.page - 1;
        await store.dispatch("fetchData", pagination.value.filters);
        await store.commit("setLoading", false);
      }
    }

    return {
      pagination,
      next,
      previous,
    };
  },
};
</script> 
  